import script from "./LandingPageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingPageView.vue?vue&type=script&setup=true&lang=ts"

import "./LandingPageView.vue?vue&type=style&index=0&id=271015b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-271015b3"]])

export default __exports__